import * as React from "react";

export const CrumbContext = React.createContext(undefined);

export const CrumbProvider = ({ children }) => {
  const [crumbs, setCrumbs] = React.useState([]);
  const crumbsRef = React.useRef([]);
  const value = {
    crumbs: crumbs.sort((a, b) => {
      if (a.id.startsWith(b.id)) {
        return 1;
      }
      if (b.id.startsWith(a.id)) {
        return -1;
      }
      return 0;
    }),
    register: (id, data) => {
      if (crumbsRef.current.find((c) => c.id === id)) {
        crumbsRef.current.find((c) => c.id === id).data = data;
      } else {
        crumbsRef.current.push({
          id,
          data,
        });
      }
      setCrumbs([...crumbsRef.current]);
    },
    unregister: (id) => {
      const index = crumbsRef.current.findIndex((c) => c.id === id);
      if (index > -1) {
        crumbsRef.current.splice(index, 1);
        return setCrumbs([...crumbsRef.current]);
      }
    },
  };
  return (
    <CrumbContext.Provider value={value}>{children}</CrumbContext.Provider>
  );
};

export const useCrumbs = () => React.useContext(CrumbContext);

export const useCrumb = (id, values) => {
  const crumbs = useCrumbs();
  React.useEffect(() => {
    return () => {
      crumbs.unregister(id);
    };
    // eslint-disable-next-line
  }, [id]);

  React.useEffect(() => {
    crumbs.register(id, values);
    // eslint-disable-next-line
  }, [values.text, values.to]);
};
